<template>
  <div id="">
    <div class="check_btn_box"></div>
    <el-table ref="multipleTable" :data="list" class="table_box">
      <el-table-column :label="$t('enum.itemName')" :width="lsitwidth" class-name="all_com">
        <template slot-scope="scope">
          <div class="com_box" :class="commodityClass">
            <div>
              <el-image class="like_img" :src="scope.row.TitImg + $store.state.thumbnail" fit="contain"></el-image>
            </div>
            <p>{{ scope.row.Title }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('enum.itemPrice')" class-name="Price" align="right">
        <template slot-scope="scope">
          <div class="com_box">
            <p>{{ SellRealMoneyUnit }} {{ USDRate ? (scope.row.Price * USDRate).toFixed(2) : 0 }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" class-name="method" align="right">
        <template slot-scope="scope">
          <div class="com_box">
            <!-- <p>{{ scope.row.method }}</p> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" class-name="method" align="right">
        <template slot-scope="scope">
          <div class="com_box">
            <p></p>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "watchlistcheck",
  data() {
    return {
      isAnswer: true,
      lsitwidth: "300",
      commodityClass: "scheduled",
    };
  },
  props: {
    list: {},
    SellRealMoneyUnit: String,
    showType: String,
    USDRate: Number
  },
  mounted() {
    if (this.showType == "auction") {
      this.lsitwidth = "300";
      this.commodityClass = "auction";
    }
    console.log(this.showType);
  },
  methods: {
    MessageBox(val, obj) {
      this.$emit("dialog", val, obj);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table_box {
  width: 100%;
}

.like_img {
  margin-right: 12px;
}

.com_box {
  display: flex;
}

.com_box p {
  width: 252px;
}

.scheduled p {
  width: 280px;
}

.auction p {
  width: 170px;
}

.check_btn_box {
  display: flex;
  line-height: 30px;
  padding: 20px 0;
}

.check_btn_box i {
  color: #5f6dae;
  margin-right: 2px;
}

.check_btn {
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  color: #c8c8c8;
  border-radius: 4px;
  margin-left: 12px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
}

.check_btn.on {
  color: #5f6dae;
  border-color: #5f6dae;
}

.all_operate div {
  cursor: pointer;
}

.all_operate div:hover {}

.el-table_1_column_2 .com_box,
.el-table_1_column_3 .com_box {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/messagelist.vue